import React from 'react';
import styled from "styled-components";

import VBLeaflet from '@virkesborsen/vb-js-commons/lib/components/new/vbLeaflet';
import { swapCoords } from '@virkesborsen/vb-js-commons/lib/components/new/leafletConfig';

import EntryDetailsMap from './components/EntryDetailMap';
import { Icon, Typography, Dropdown, Textarea, Button} from '@virkesborsen/ui-component-library';
import { Chip } from './components/Chip';
import { Spinner } from 'react-bootstrap';
import { ErrorModal } from '../../../modals';

import { PropsData, Navigation } from '../context';
import { useDFR } from '../context/DFRContext';

import { sendEvent } from '../../../api/services/main';
import { useDrone } from '../context/DroneContext';

const RoundedDiv = styled.div`
    padding: 16px;
    border-radius: 16px;
`

const LoggItem = styled.div`
    background: white;
    border: 1px solid #E2E1E0;
    border-radius: 16px;
    padding: 16px;
    margin-bottom: 16px;
`

export default function EntryDetail(props) {
    const DFRContext = useDFR();
    const { setIsDroneDialogOpen } = useDrone();
    const navContext = React.useContext(Navigation);
    const propsContext = React.useContext(PropsData);

    const leaflet = React.useRef(null);

    const [loading, setLoading] = React.useState(['editButtons', 'createComment', 'createState',]);
    const [newComment, setNewComment] = React.useState({});
    const [editComment, setEditComment] = React.useState([]);
    const [entry, setEntry] = React.useState(props.entry ?? history.state.entry);
    const [statusSuccess, showStatusSuccess] = React.useState(false)
    const [rtcSend, setRtcSend] = React.useState(false)

    const [errorModal, setErrorModal] = React.useState(false)

    const currentState = entry.states.filter(s => !s.deleted)[0]

    const waitForMapThenSetData = async () => {
        if(!leaflet.current.state.map) {
            setTimeout(() => waitForMapThenSetData(), 100)
        } else {
            setGeom()
        }
    }

    const waitForData = async () => {
        const isReady = propsContext.props.some(p => p.ref == entry.ref && p.status === 'data' && p.data && p.ready)

        if(!isReady) {
            setTimeout(() => waitForData(), 100)
        } else {
            if(currentState.state == 'unseen') {
                await DFRContext.addState(entry.id, {state: 'seen'})
            }
            setLoading([])
        }
    }

    React.useEffect(() => {
        waitForData()
    }, []);

    React.useEffect(() => {
        const updatedEntry = DFRContext.entries.find(e => e.id == entry.id)
        if(updatedEntry) {
            setEntry(updatedEntry)
            history.replaceState({...history.state, entry: updatedEntry}, '', '');
        }
    }, [DFRContext.entries])

    React.useEffect(() => {
        if(entry.geom && !navContext.view.showMap) {
            waitForMapThenSetData()
        }
    }, [navContext.view.showMap])

    const setGeom = () => {
        let map = leaflet.current.state.map
        let geomFG = L.featureGroup([])
        entry.geom.forEach((geom) => {
            
            if(geom.type === 'Polygon') {
                const color = '#bb0000'

                const baseStyle = {
                    color: color,
                    fillColor: color,
                    opacity: 1,
                    fillOpacity: 0.5,
                    weight: 2,
                    type: 'polygon'
                }


                let layer = L.polygon(swapCoords(geom.coordinates), baseStyle)
                layer.addTo(geomFG)
            }

            if(geom.type === 'LineString') {
                const color = '#bb0000'

                const baseStyle = {
                    color: color,
                    fillColor: color,
                    opacity: 1,
                    fillOpacity: 0.5,
                    weight: 2,
                }

                const lineString = {
                    type: "Feature",
                    geometry: geom
                }

                let layer = L.geoJSON(lineString, baseStyle)
                layer.addTo(geomFG)
            }

            if(geom.type === 'MultiPolygon') {
                const color = '#bb0000'

                const baseStyle = {
                    color: color,
                    fillColor: color,
                    opacity: 1,
                    fillOpacity: 0.5,
                    weight: 2,
                }
                const multiPolygon = {
                    type: "Feature",
                    geometry: geom
                };
                
                let layer = L.geoJSON(multiPolygon, baseStyle)
                layer.addTo(geomFG)
            }

            if(geom.type === 'MultiPoint') {
                const color = '#bb0000'

                const baseStyle = {
                    color: color,
                    fillColor: color,
                    opacity: 1,
                    fillOpacity: 0.5,
                    weight: 2,
                }
                const multiPoint = {
                    type: "Feature",
                    geometry: geom
                };
                
                let layer = L.geoJSON(multiPoint, baseStyle)
                layer.addTo(geomFG)
            }
            
            if(geom.type === 'Point') {
                const icon = L.icon({
                    iconUrl: `${Window.static_path}img/map-markers/marker-location.svg`,
                    iconSize: [40, 57],
                    shadowSize: [40, 57],
                    iconAnchor: [20, 57],
                    shadowAnchor: [40, 57],
                    popupAnchor: [0, -32]
                })

                let marker = L.marker([geom.coordinates[1], geom.coordinates[0]], { icon: icon, type: 'marker' })

                marker.addTo(geomFG)
            }

            
        })
        leaflet.current.setLayers(geomFG)
        geomFG.addTo(map)
        
        map.fitBounds(geomFG.getBounds())
    }

    const fetchCTA = () => {
        const buyDroneList = ['Hög vind i riskområde', 'Aktiv brand - möjlig skogsbrand', 'Möjlig höjdförändring i området', 'Granbarkborre / Döda träd']
        const beContactedList = ['Avverkningsanmälan i närheten']

        if(buyDroneList.includes(entry.title)) {
            return <Button label='Köp drönarinventering' className='mt-2' onClick={() => {setIsDroneDialogOpen(true)}} />
        }
        if(beContactedList.includes(entry.title)) {
            return rtcSend == 'send' ? <div className='d-flex mt-2'>
                    <Icon name='CheckOutlined' color='success-900' size='medium'/>
                    <Typography variant='labelSmallMedium' color='success-900' className='ms-1'>Vi kommer att kontakta dig.</Typography>
                </div> : <div className='d-flex align-items-center gap-2 mt-2'>
                    <Button label='Bli kontaktad' disabled={rtcSend == 'loading'} onClick={async () => {
                        setRtcSend('loading')
                        const resp = await sendEvent('request_to_contact', {source: 'dfr_entry_detail_cta', entry_id: entry.id, entry_title: entry.title})
                        if(resp.ok) {
                            setRtcSend('send')
                        } else {
                            setErrorModal(true)
                            setRtcSend(false)
                        }
                    }} />
                    {rtcSend == 'loading' && <Spinner animation="border" role="status" size="sm" />}
                </div>
        }
        return <></>
    }

    const addLoading = string => {
        let loadingSet = new Set(loading)
        loadingSet.add(string)
        setLoading([...loadingSet])
    }

    const updateState = async update => {
        addLoading(`updateState${update.id}`)
        await DFRContext.updateState(entry.id, update)
        setLoading(prevLoading => prevLoading.filter(i => i !== `updateState${update.id}`))
    }

    const addNewState = async state => {
        addLoading('createState')
        const addStateResp = await DFRContext.addState(entry.id, state)
        if(addStateResp) {
            showStatusSuccess(true)
        } else {
            // Do a error handling thing here. (Error modal probably)
        }
        setLoading(prevLoading => prevLoading.filter(i => i !== 'createState'))
    }

    const updateComment = async update => {
        addLoading(`updateComment${update.id}`)
        await DFRContext.updateComment(entry.id, update)
        setLoading(prevLoading => prevLoading.filter(i => i !== `updateComment${update.id}`))
    }

    const addNewComment = async () => {
        addLoading('createComment')
        await DFRContext.addComment(entry.id, newComment)
        setNewComment({})
        setLoading(prevLoading => prevLoading.filter(i => i !== 'createComment'))
    }

    const handleHistory = () => {
        const view = {...navContext.view, showMap: true}
        history.pushState(view, '', '')
        navContext.setView(view)
    }

    const renderLoggItem = item => {
        const name = item.text ? 'Kommentar' : 'Status'
        const title = item.text ? 'Kommentar' : 'Status uppdatering'
        const loadingCheck = item.text ? `updateComment${item.id}` : `updateState${item.id}`
        const action = item.text ? updateComment : updateState

        return <LoggItem>
            <div className='d-flex flex-column justify-content-between'>
                {item.deleted ? <div className='d-flex align-items-center justify-content-between'>
                    <Typography variant='labelSmallRegular'>Borttagen {name}</Typography>

                    {(loading.includes('editButtons') || loading.includes(loadingCheck)) ? <Spinner animation="border" role="status" size="sm" /> : <Typography onClick={() => action({id: item.id, deleted: false})} className='green-pine-500 text-decoration-underline' style={{cursor: 'pointer'}} variant='labelSmallRegular'>ångra val</Typography>}
                </div> : <>
                    <div className='d-flex'>
                        <Icon name={`${item.state ? 'ArrowsUpdate' : 'CommentBoxSimple'}`} size="large" />
                        <Typography className='ms-2' variant='labelMediumMedium'>{title}</Typography>
                    </div>

                    {!item.state && editComment.find(e => e.id == item.id) ? <>
                        <Textarea className='bg-white' value={editComment.find(e => e.id == item.id).text} onChange={(value) => setEditComment(editComment.map(c => c.id == item.id ? {...c, text: value} : c))} />

                        <div className='d-flex align-items-center'>
                            <Button className='me-2' label='Avbryt' variant='secondary' onClick={() => setEditComment(editComment.filter(c => c.id != item.id))} disabled={loading.includes(loadingCheck)}/>
                            <Button label='Uppdatera' onClick={async () => {await action(editComment.find(e => e.id == item.id)); setEditComment(editComment.filter(c => c.id != item.id))}} disabled={loading.includes(loadingCheck)}/>
                            {loading.includes(loadingCheck) && <Spinner className='ms-2' animation="border" role="status" size="sm" />}
                        </div>
                    </> : <>
                        <Typography className='my-2' variant='bodySmallRegular'>{item.state ? `Uppdaterat status till ${item.text_repr}` : item.text}</Typography>

                        <div className='d-flex justify-content-between'>
                            <Typography className='pebble-500' variant='labelSmallRegular'>{item.created_at.slice(0, 10)}</Typography>

                            {(loading.includes('editButtons') || loading.includes(loadingCheck)) ? <Spinner animation="border" role="status" size="sm" /> : <div className='d-flex'>
                                {item.text && <div role='button' onClick={() => setEditComment([...editComment, {id: item.id, text: item.text}])}>
                                    <Icon className='me-2' name='EditPenSimple' size="medium" />
                                </div>}

                                <RoundedDiv className='d-none'>
                                    <Typography variant='labelSmallMedium'>Avbryt</Typography>
                                    <Typography variant='labelSmallMedium'>Ta bort</Typography>
                                </RoundedDiv>

                                {(item.text || (item.state && entry.states.filter(s => !s.deleted).length > 1)) && <div role='button' onClick={() => action({id: item.id, deleted: true})}>
                                    <Icon name='TrashBinSimple' size="medium" />
                                </div>}
                            </div>}
                        </div>
                    </>}
                </>}
            </div>
        </LoggItem>
    }

    const combinedUpdates = () => {
        const combined = [...entry.comments, ...entry.states]

        return combined.sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
        })
    }

    const renderDescription = desc => {
        const urlRegex = /(https?:\/\/\S+)/g;
        const parts = desc.split(urlRegex);

        return parts.map((part, index) => {
            return /(https?:\/\/\S+)/.test(part) ? <a className='green-spruce-700 fw-bold' href={part} key={index} target="_blank">{part}</a> : part;
        });
    }

    return <>
        {navContext.view.showMap ? <EntryDetailsMap geom={entry.geom} border={propsContext.props.find(p => p.ref == entry.ref).border} /> :
        <div className={`position-relative ${!navContext.view.showMap && 'p-3'}`} style={{maxWidth: '960px'}}>
            <div className='d-flex flex-column'>
                <div role='button' onClick={() => window.history.back()} className='d-flex fit-content'>
                    <Icon name="ChevronDownSimple" size="large" rotation={90} />
                    <Typography variant="labelLargeRegular">Tillbaka</Typography>
                </div>
            </div>

            {entry && <div className='row mt-3'>
                <div className='col-12 col-lg-7'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Chip type={currentState.state} />
                        <Typography variant='captionRegular' color='cloud-900'>{entry.designation}</Typography>
                    </div>
                    

                    <Typography className='mt-3' variant='subheaderSmallMedium'>{entry.title}</Typography>

                    <Typography className='my-3' variant='introLeadMediumRegular'>{renderDescription(entry.description)}</Typography>

                    {entry.geom && <div role='button' onClick={() => handleHistory()} style={{height: '450px'}}>
                        <VBLeaflet ref={leaflet} id='map_karta' baseMap='Mapbox Satelite' mapOptions={{interactive: false, dragging: false, touchZoom: false, scrollWheelZoom: false, doubleClickZoom: false, boxZoom: false, keyboard: false, tap: false, zoomControl: false}} />
                    </div>}

                    {entry.action && <div className='d-flex rounded bg-cloud-200 mt-3' style={{padding: '12px', border: '1px solid #EBEBEB'}}>
                        <div style={{marginRight: '12px', marginTop: '3px'}}>
                            <Icon name='InfoFilled' color='pebble-500' size='large' />
                        </div>

                        <div>
                            <Typography variant='labelMediumMedium'>Rekommenderad åtgärd</Typography>

                            <Typography variant='bodySmallRegular' color='pebble-500'>{entry.action}</Typography>

                            {fetchCTA()}
                        </div>
                    </div>}
                </div>

                <div className='col-12 col-lg-5 mt-3 mt-lg-0'>
                    <RoundedDiv className='bg-stone-50 mb-3'>
                        <Typography variant="labelMediumMedium">Status på ärende</Typography>

                        <Dropdown value={currentState.state} options={DFRContext.states} onChange={(value) => {value != currentState.state && addNewState({state: value})}} disabled={loading.includes('createState')} onFocus={() => showStatusSuccess(false)} />

                        {statusSuccess && <div className='d-flex ps-2'>
                            <Icon name='CheckOutlined' color='success-900' size='small'/>
                            <Typography variant='labelXtraSmallRegular' color='success-900' className='ms-1'>Status har uppdaterats</Typography>
                        </div>}
                    </RoundedDiv>

                    <RoundedDiv className='bg-stone-50'>
                        <Typography variant='labelMediumMedium'>Lämna en kommentar</Typography>

                        <Textarea value={newComment?.text} className='bg-white' onChange={(value) => setNewComment({...newComment, text: value})} />

                        {/*<Typography variant='labelMediumMedium'>Ställ in en påminnelse</Typography>
                        <Button className='my-2' variant='secondary' label='Välj datum' prefixIcon='DateCalendarSimple' fullWidth />*/}

                        <Button label='Lägg till kommentar' onClick={addNewComment} fullWidth disabled={loading.includes('createComment')} />

                        <Typography className='my-3' variant='labelMediumMedium'>Logg</Typography>

                        {combinedUpdates().map(update => {
                            return renderLoggItem(update)
                        })}
                    </RoundedDiv>
                </div>
            </div>}
        </div>}

        {/* ERROR Modal */}
        <ErrorModal show={errorModal} onToggle={() => setErrorModal(false)} />
    </>
}